'use strict';
import angular from 'angular';
import './base/industrybenchmarkemail.resources';


angular.module('core.industrybenchmarkemail', [
    'industrybenchmarkemail.resources'
]);